import {CreateRoleInput} from './dto/createRoleInput'
import {CreateRoleOutput} from './dto/createRoleOutput'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {GetAllRoleOutput} from './dto/getAllRoleOutput'
import {GetRoleAsyncInput} from './dto/getRolesAsyncInput'
import GetRoleAsyncOutput from './dto/getRoleAsyncOutput'
import {GetRoleForEditOutput, Role} from './dto/getRoleForEditOutput'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import {PagedRoleResultRequestDto} from './dto/PagedRoleResultRequestDto'
import {UpdateRoleInput} from './dto/updateRoleInput'
import {UpdateRoleOutput} from './dto/updateRoleOutput'
import axios from 'axios'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Role/Create`
export const URL_DELETE = `${API_URL}/Role/Delete`
export const URL_GET = `${API_URL}/Role/Get`
export const URL_GET_ASYNC = `${API_URL}/Role/GetRolesAsync`
export const URL_GET_ALL = `${API_URL}/Role/GetAll`
export const URL_UPDATE = `${API_URL}/Role/Update`
export const URL_GET_FOR_EDIT = `${API_URL}/Role/GetRoleForEdit`
export const URL_GET_PERMISSIONS = `${API_URL}/Role/GetAllPermissions`
export const URL_GET_USER_ROLES = `${API_URL}/Role/GetUserRoles`

export function onCreateRole(
  createRoleInput: CreateRoleInput
): Promise<PagedResultDto<CreateRoleOutput>> {
  return axios.post(URL_CREATE, createRoleInput)
}

export function onGetRolesAsync(getRoleAsyncInput: GetRoleAsyncInput): Promise<GetRoleAsyncOutput> {
  return axios.get(URL_GET_ASYNC, {params: getRoleAsyncInput})
}

export function onUpdateRole(updateRoleInput: UpdateRoleInput): Promise<UpdateRoleOutput> {
  return axios.put(URL_UPDATE, updateRoleInput)
}

export function onDeleteRole(entityDto: EntityDto) {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetAllPermissions() {
  return axios.get(URL_GET_PERMISSIONS)
}

export function onGetRoleForEdit(entityDto: EntityDto): Promise<GetRoleForEditOutput> {
  return axios.get(URL_GET_FOR_EDIT, {params: entityDto})
}

export function onGetRole(entityDto: EntityDto) {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetUserRoles() {
  return axios.get(URL_GET_USER_ROLES);
}

export function onGetAllRoles(
  pagedFilterAndSortedRequest: PagedRoleResultRequestDto
): Promise<PagedResultDto<GetAllRoleOutput>> {
  return axios.get(URL_GET_ALL, {
    params: pagedFilterAndSortedRequest,
  })
}
